import React from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';

import { translate as t } from 'hooks/useTranslations';

const BaseAttachmentDisplay: React.FC = () => {
  return (
    <Box sx={{ pointerEvents: 'none', opacity: 0.6 }}>
      <Stack spacing={2}>
        <Box
          sx={{
            border: '2px dashed',
            borderColor: 'divider',
            borderRadius: 1,
            backgroundColor: 'action.hover',
            py: 3,
            px: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
          }}
        >
          <CloudUploadOutlinedIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
          <Typography sx={{ color: 'primary.main', textDecoration: 'underline', fontWeight: 500 }}>
            {t('performanceReporting.fieldBank.attachmentDisplay.clickToAdd')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('performanceReporting.fieldBank.attachmentDisplay.dragAndDrop')}
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 600, color: 'text.primary' }}>
            {t('performanceReporting.fieldBank.attachmentDisplay.orUploadUrl')}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              placeholder={t('performanceReporting.fieldBank.attachmentDisplay.urlPlaceholder')}
              size="small"
              fullWidth
              disabled
              variant="outlined"
              sx={{ flex: 1 }}
            />
            <Button variant="outlined" disabled size="small">
              {t('performanceReporting.fieldBank.attachmentDisplay.upload')}
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default BaseAttachmentDisplay;
